import { PrestationAvecPrix } from '../types';

// Données d'exemple pour le module Meilleur Fournisseur
export const mockPrestations: PrestationAvecPrix[] = [
  {
    id: '1',
    intitule: 'Maintenance ascenseur mensuelle',
    quantite: 12,
    unite: 'mois',
    prixParFournisseur: [
      { fournisseur: 'A', prixUnitaire: 450.00 },
      { fournisseur: 'B', prixUnitaire: 480.00 },
      { fournisseur: 'C', prixUnitaire: 420.00 },
    ],
  },
  {
    id: '2',
    intitule: 'Révision annuelle complète',
    quantite: 1,
    unite: 'an',
    prixParFournisseur: [
      { fournisseur: 'A', prixUnitaire: 2500.00 },
      { fournisseur: 'B', prixUnitaire: 2300.00 },
    ],
  },
  {
    id: '3',
    intitule: 'Remplacement câbles',
    quantite: 4,
    unite: 'unité',
    prixParFournisseur: [
      { fournisseur: 'A', prixUnitaire: 180.00 },
      { fournisseur: 'B', prixUnitaire: 195.00 },
      { fournisseur: 'C', prixUnitaire: 175.00 },
    ],
  },
  {
    id: '4',
    intitule: 'Inspection sécurité trimestrielle',
    quantite: 4,
    unite: 'trimestre',
    prixParFournisseur: [
      { fournisseur: 'C', prixUnitaire: 320.00 },
    ],
  },
];

